export default function OurSolution() {
  const solutions = [
    {
      icon: 'ri-shield-check-line',
      title: '回収率0.5％の実績',
      description: '独自の審査と管理体制により、極めて低い貸し倒れ率を実現。'
    },
    {
      icon: 'ri-refresh-line',
      title: '車両回転モデル',
      description: '万が一の際も、車両を確実に回収し、次へと繋げる資産管理体制。'
    },
    {
      icon: 'ri-map-pin-line',
      title: '警察連携＆GPS',
      description: '位置情報の常時把握と即時アラートにより、持ち逃げを許さない物理的な管理。'
    },
    {
      icon: 'ri-hand-heart-line',
      title: '連帯保証スキーム',
      description: '販売店自身が連帯保証することで、投資家の収益が守られる二重の安全策。'
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#1A2B4A] leading-tight mb-6 font-serif">
            では、なぜリトラストは成立しているのか<br />
            <span className="text-3xl md:text-4xl">金融×テクノロジー×法執行を組み合わせた独自の鉄壁スキーム</span>
          </h2>
          <div className="w-32 h-1 bg-[#D4AF37] mx-auto mt-8" style={{
            backgroundImage: 'repeating-linear-gradient(90deg, #D4AF37 0, #D4AF37 10px, transparent 10px, transparent 20px)',
          }}></div>
        </div>

        {/* Key Message */}
        <div className="max-w-4xl mx-auto mb-16 text-center">
          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            その鍵は、事故回収率<span className="text-[#D4AF37] font-bold text-3xl">「0.5%」</span>という数字にあります。
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            私たちは、個人の信用力に依存する従来のファイナンスではなく、<span className="text-[#1A2B4A] font-bold">「車両の資産価値」</span>を軸とした全く新しい仕組みを構築しました。
          </p>
        </div>

        {/* Solution Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="group bg-white border-2 border-[#1A2B4A] rounded-3xl p-8 hover:shadow-2xl hover:shadow-[#D4AF37]/30 transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-20 h-20 flex items-center justify-center bg-[#D4AF37] rounded-full mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${solution.icon} text-white text-4xl`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-[#1A2B4A] text-center mb-4 leading-tight">
                {solution.title}
              </h3>

              {/* Description */}
              <p className="text-base text-gray-600 text-center leading-relaxed">
                {solution.description}
              </p>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="text-center">
          <p className="text-lg text-gray-600 mb-8">
            この具体的な運用フローについては、セミナー内でのみ詳しくお伝えします
          </p>

          {/* CTA Button - Mobile Optimized */}
          <div className="flex justify-center px-4">
            <a 
              href="https://forms.gle/vdJZoFV3tEuxApQD7"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-gradient-to-r from-[#D4AF37] to-[#F4C542] text-white font-bold text-xs md:text-lg px-4 md:px-12 py-3 md:py-5 rounded-full inline-flex items-center gap-2 md:gap-4 hover:shadow-2xl hover:shadow-[#D4AF37]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer w-full md:w-auto max-w-[90%] md:max-w-none justify-center"
            >
              【無料】WEBセミナーで詳しく聞く
              <div className="w-7 h-7 md:w-10 md:h-10 flex items-center justify-center bg-white rounded-full group-hover:translate-x-1 transition-transform duration-300 flex-shrink-0">
                <i className="ri-arrow-right-line text-[#D4AF37] text-base md:text-xl"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}